import styled, { css } from 'styled-components'

import { Col } from 'react-styled-flexboxgrid-tmp'
import { TERTIARY_COLOR } from '@CSSVars/colors'

import AmenityWithLink from '../AmenityWithLink'


export const _Amenity = styled(Col)`
  display: flex;
  align-items: center;
  margin: ${({ isprintstyle }) => (isprintstyle ? '0' : '6px 0')};
  font-size: 0;
  padding: ${({ isprintstyle }) => (isprintstyle ? '3px 0' : '0 8px 0 0')};

  /*transform: translateX(5px);*/

  div {
    line-height: ${({ isprintstyle }) => (isprintstyle ? '12px' : 'inherit')};
    font-size: ${({ isprintstyle }) => (isprintstyle ? '12px' : 'inherit')};
  }

  ${({ isprintstyle }) => (
    isprintstyle ?
      `
        svg {
          height: 15px!important;
          width: 15px!important;
        }
      ` : ''
  )}

  ${({ isLinkStyle }) => (
    isLinkStyle ?
      `
        svg {
          path {
            fill: ${TERTIARY_COLOR};
          }
        }
        a {
          color: ${TERTIARY_COLOR};
          text-decoration: underline;
        }
      ` : ''
  )}
`

export const _SvgHolder = styled.div`
  font-size: 0;
  margin-right: 14px;
`

const iconCont = css`
  position: relative;
  line-height: 20px!important;
`

export const _CopyContDiv = styled.div`
  ${iconCont};
  height: ${({ isPrint }) => (isPrint ? '15px' : 'auto')};
  font-size: ${({ isPrint }) => (isPrint ? '11px!important' : '14px!important')};
  white-space: ${({ isPrint }) => (isPrint ? 'nowrap' : 'normal')};
`

export const _CopyContAmenityWithLink = styled(AmenityWithLink)`
  ${iconCont};
  height: ${({ isPrint }) => (isPrint ? '15px' : 'auto')};
  font-size: ${({ isPrint }) => (isPrint ? '11px!important' : '14px!important')};
  white-space: ${({ isPrint }) => (isPrint ? 'nowrap' : 'normal')};

`
